import { Clock02Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@motley/design"
import { Link, useMatchRoute } from "@tanstack/react-router"
import { useCurrentTenant } from "@/tenant"

export default function RunsMenu() {
  const { tenantSlug } = useCurrentTenant()
  const matchRoute = useMatchRoute()
  const isActive = !!matchRoute({ to: "/t/$tenantSlug/runs" })

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          isActive={isActive}
          render={
            <Link to="/t/$tenantSlug/runs" params={{ tenantSlug }}>
              <HugeiconsIcon icon={Clock02Icon} />
              Runs
            </Link>
          }
        />
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
